"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var OptimizationGoalsSettings_1 = require("../../model/optimalization-goal/OptimizationGoalsSettings");

var OptimizationGoalsSettingsConverter_1 = require("./OptimizationGoalsSettingsConverter");
/**
 * Default implementation of {@link OptimizationGoalsSettingsConverter}.
 *
 * @author RV
 */


var OptimizationGoalsSettingsConverterImpl =
/*#__PURE__*/
function (_OptimizationGoalsSet) {
  _inherits(OptimizationGoalsSettingsConverterImpl, _OptimizationGoalsSet);

  function OptimizationGoalsSettingsConverterImpl() {
    _classCallCheck(this, OptimizationGoalsSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(OptimizationGoalsSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(OptimizationGoalsSettingsConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new OptimizationGoalsSettings_1.OptimizationGoalsSettings(conversions.asEnumOpt(source.optimalizationGoal, OptimizationGoalsSettings_1.OptimizationGoal));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        optimalizationGoal: source.optimalizationGoal
      });
      return result;
    }
  }]);

  return OptimizationGoalsSettingsConverterImpl;
}(OptimizationGoalsSettingsConverter_1.OptimizationGoalsSettingsConverter);

exports.OptimizationGoalsSettingsConverterImpl = OptimizationGoalsSettingsConverterImpl;